import React from "react";

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            Ciao, io sono Mattia.
            <br className="hidden lg:inline-block" />Adoro l'efficienza.
          </h1>
          <p className="mb-8 leading-relaxed">
            Ho lavorato anni in diversi settori, ma l'unico punto fisso nella vita
            è stato lo sviluppo software, per cui voglio dedicarmi a ci&ograve; che
            mi piace e aiutare il prossimo con quello che mi appassiona.
          </p>
          <div className="flex justify-center">
            <a
              href="#contact"
              className="inline-flex text-white bg-primary-400 border-0 py-2 px-6 focus:outline-none hover:bg-primary-500 rounded text-lg">
              Lavora con me
            </a>
            <a
              href="#projects"
              className="ml-4 inline-flex text-white bg-secondary-200 border-0 py-2 px-6 focus:outline-none hover:bg-secondary-300 hover:text-white rounded text-lg">
              Vedi software realizzati
            </a>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded"
            alt="hero"
            src="./coding.svg"
          />
        </div>
      </div>
    </section>
  );
}
